<template>
  <div class="AddressList">
    <span role="status" class="sr-only">{{addressesFoundText}}</span>
    <ul
      v-if="addresses.length > 0"
      id="AddressListMenu"
      class="AddressList__menu-list"
      role="listbox"
      @keydown.down="focusOnListItem"
      @keydown.up="focusOnPreviousItem"
      tabindex="0">
      <li v-for="(address, index) in addresses" class="AddressList__menu-item" :key="`address-${index}`">
        <div
          tabindex="0"
          role="option"
          class="AddressList__menu-item-wrapper"
          @click="$emit('setAddressInfo', address, getStreetAddress(address))"
          @keydown.enter="$emit('setAddressInfo', address, getStreetAddress(address))"
        >
          <span v-html="getFormattedStreetAddress(address)" />
          <span v-if="address.entries" class="AddressList__menu-item-arrow"><b-icon-arrow-right /></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AddressList',
  props: {
    addresses: { type: Array },
  },
  data() {
    return {
      focusedIndex: -1,
      focusedLength: '',
      focusOptions: [],
    };
  },
  computed: {
    addressesFoundText() {
      if (this.addressesFound) {
        return 'Address suggestions have been found, use tab or down arrow to view suggestions';
      }
      return '';
    },
    addressesFound() {
      if (this.addresses.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getStreetAddress(address) {
      let autoCompleteAddress = `${address.streetLine} ${address.city} ${address.state} ${address.zipcode}`;

      if (address.entries && address.secondary) {
        if (address.entries > 1) {
          autoCompleteAddress = `${address.streetLine} ${address.secondary} (${address.entries}) ${address.city} ${address.state} ${address.zipcode}`;
        } else {
          autoCompleteAddress = `${address.streetLine} ${address.secondary} ${address.city} ${address.state} ${address.zipcode}`;
        }

        return autoCompleteAddress;
      }

      return autoCompleteAddress;
    },
    getFormattedStreetAddress(address) {
      const str = this.getStreetAddress(address);
      const currentAddress = this.$store.state.AddressLine1;
      const addressArray = str.split(currentAddress);

      if (addressArray.length > 1) {
        return `${currentAddress}<strong>${addressArray[1]}</strong>`;
      }

      return str;
    },
    focusOnListItem(event) {
      const getAllOptions = document.getElementsByClassName('AddressList__menu-item-wrapper');
      this.focusedLength = getAllOptions.length;
      this.focusOptions = getAllOptions;
      // if (!document.activeElement.classList.contains('AddressList__menu-item-wrapper')) {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   getAllOptions[0].focus();
      //   this.focusedIndex += 1;
      // }// eslint-disable-next-line no-tabs
      event.preventDefault(); // prevent scroll, we are setting focus
      event.stopPropagation(); // prevent scroll, we are setting focus
      if (this.focusedIndex < this.focusedLength && this.focusedIndex !== (this.focusedLength - 1)) {
        this.focusedIndex += 1;
        this.focusOptions[this.focusedIndex].focus();
      }
    },
    focusOnNextItem() {
      // if (this.focusedIndex < this.focusedLength) {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   this.focusOptions[this.focusedIndex].focus();
      //   this.focusedIndex += 1;
      // }
    },
    focusOnPreviousItem(event) {
      event.preventDefault(); // prevent scroll, we are setting focus
      event.stopPropagation(); // prevent scroll, we are setting focus
      if (this.focusedIndex > 0) {
        // console.log(this.focusedIndex);
        this.focusedIndex += -1;
        this.focusOptions[this.focusedIndex].focus();
      } else {
        const AddressUlEl = document.getElementById('address');
        AddressUlEl.focus();
        this.focusedIndex = -1;
        // console.log(this.focusedIndex);
      }
    },
    focusOnInput() {
      const addressInputEl = document.getElementById('address');
      const AddressUlElB = document.getElementById('AddressListMenu');
      if (document.activeElement === AddressUlElB) {
        addressInputEl.focus();
      }
    },
  },
};
</script>

<style lang="scss">
  .AddressList {
    background: white;
    position: absolute;
    width: 100%;
    z-index: 100;
    max-height: 220px;
    overflow-y: scroll;

    &__menu-list {
      margin: 0;
      padding: 0;
      list-style-type: none;
      color: black;
      font-size: 14px;
    }

    &__menu-item-wrapper {
      @extend %roboto-font-regular;
      padding: 6px 0 6px 5px;
      cursor: pointer;

      &:hover,
      &:focus {
        background: $gray-200;
      }

      strong {
        @extend %roboto-font-bold;
      }
    }

    &__menu-item-arrow {
      padding-left: 5px;
    }
  }
</style>
